module.exports = __webpack_public_path__ + "static/media/cockroach(25).f74e7957.PNG";